// Dependencies
import Axios from "axios";

export class AdminClient {
  constructor(apiUrl, headers) {
    // Set admin url
    this.adminUrl = `${apiUrl}/admin`;
    this.headers = headers;
  }

  setHeaders(headers) {
    this.headers = headers;
  }

  async getProfiles() {
    const url = `${this.adminUrl}/profiles`;

    const response = await Axios.get(
      url, { headers: this.headers }
    );

    return response;
  }
}



// WEBPACK FOOTER //
// ./src/clients/BackendAdminClient/admin.js